// extracted by mini-css-extract-plugin
export default {"cls1":"render-cls1_NSu","cls2":"render-cls2_lLs render-cls1_NSu"};